import { SnowplowService } from 'wanderu-service-analytics';

function tripSelected({ date, index }) {
    SnowplowService.fireStructuredEvent({
        category: 'c2c_time_table',
        label: index
            ? 'time_table_trip_select'
            : 'time_table_see_more',
        action: 'click',
        property: JSON.stringify({
            date,
            trip_index: index,
        }),
    });
}

export default { tripSelected };
